import React, { createContext, useContext, useEffect, useState } from "react";
import CartService from "services/cart";
import _ from "lodash"
import { useAuth } from "contexts/auth"
import { useApp } from "contexts/app"
import { useLocation } from 'react-router'
const CartContext = createContext(null);
const service = new CartService();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState(null);
    const { setProcessing, setPageTitle, showToast, setShowProductSearch } = useApp();
    const { user } = useAuth();
    const [loading, setLoading] = useState(true);
    let location = useLocation();
    useEffect(() => {
        //user login 
        console.log("cart load", user)

    }, [])


    useEffect(() => {
        loadCart();
    }, [user])

    useEffect(() => {
        console.log("cart", cart)
    }, [cart]);


    const loadCart = async () => {

        try {
            var cart_id = localStorage.getItem("cart_id");
            if (user) {

                if (cart_id) {

                    await service.setCustomer({ id: cart_id });
                    var currentCart = await service.get(cart_id);
                    setCart(currentCart)

                } else {
                    var currentCart = await service.getCurrent();
                    setCart(currentCart);
                }




            } else {

                var currentCart = await service.get(cart_id);
                if (currentCart) {
                    setCart(currentCart);
                    localStorage.setItem("cart_id", currentCart.id);
                } else {
                    var currentCart = await service.create();
                    setCart(currentCart);
                    localStorage.setItem("cart_id", currentCart.id);
                }
                // setCart(currentCart);

            }
        } catch (error) {
            await create();
        }




    }



    const create = async () => {
        if (user) {
            localStorage.removeItem("cart_id");
            var newCart = await service.getCurrent();
            setCart(newCart)

            return newCart;

        } else {
            var newCart = await service.create();
            setCart(newCart)
            localStorage.setItem("cart_id", newCart.id)
            return newCart;
        }


    }

    const newCart = async () => {
        if (user) {

        } else {

        }
    }

    const addToCart = async (productId, quantity = 1) => {
        var cartID = await getCurrentCartID();
        var updatedCart = await service.addLineItem({ id: cartID, line: { product_id: productId, quantity: quantity } })
        setCart(updatedCart);

    };

    const addMultiItemToCart = async (lineItems = []) => {
        var cartID = await getCurrentCartID();
        var updatedCart = await service.addMultiLineItem({ id: cartID, line_items: lineItems })
        setCart(updatedCart);

    };


    const updateLineItem = async (productId, quantity = 1) => {
        var cartID = await getCurrentCartID();

        var updatedCart = await service.updateLineItem({ id: cartID, line: { product_id: productId, quantity: quantity } })
        setCart(updatedCart);

    };

    const removeLineItem = async (productId) => {
        var cartID = await getCurrentCartID();
        var updatedCart = await service.updateLineItem({ id: cartID, line: { product_id: productId, quantity: 0 } })
        setCart(updatedCart);

    };

    const calculateItemPrice = async (variant, quantity) => {

        if (!variant) {

            return 0;
        }


        var priceList = _.sortBy(variant.price_list, v => v.min * -1);
        for (let index = 0; index < priceList.length; index++) {
            const price = priceList[index];
            if (quantity >= price.min) {
                return price.price;

            }

        }
        return variant.original_price ?? 0;

    }
    const updateShippingAddress = async (shipping_address) => {
        var cartID = await getCurrentCartID();
        var updatedCart = await service.updateShippingAddress({ id: cartID, shipping_address })
        setCart(updatedCart);

    };


    const createInvoiceFile = async () => {
        var cartID = await getCurrentCartID();
        var updatedCart = await service.createInvoiceFile({ id: cartID })
        setCart(updatedCart);
        return updatedCart;
    }


    const getCurrentCartID = async () => {
        var cart_id = localStorage.getItem("cart_id");
        if (cart_id) {
            return cart_id;
        } else {
            var newCart = await create();
            localStorage.setItem("cart_id", newCart.id);
            return newCart.id;
        }
        return null;
        // if (!cart) {
        //     var newCart = await create();
        //     return newCart.id;
        // }
        // else {
        //     return cart.id;
        // }

    }


    const completeCart = async () => {
        return await service.complete({ id: cart.id })
    }

    const validateInventory = async () => {
        const cartID = await getCurrentCartID();
        return await service.validateInventory({ id: cartID })
    }

    const setVoucher = async (code) => {
        setProcessing(true);
        var newCart = await service.setVoucher({ id: cart.id, voucher_code: code })
        setCart(newCart);
        setProcessing(false);
        return newCart;
    }
    const removeVoucher = async () => {
        setProcessing(true);
        var newCart = await service.removeVoucher({ id: cart.id })
        setCart(newCart);
        setProcessing(false);
        return newCart;
    }



    const setPoint = async (point) => {
        setProcessing(true);
        try {
            var newCart = await service.setPoint({ id: cart.id, point })
            setCart(newCart);
            return newCart;
        } finally {
            setProcessing(false);
        }
    }
    const removePoint = async () => {
        setProcessing(true);
        var newCart = await service.removePoint({ id: cart.id })
        setCart(newCart);
        setProcessing(false);
        return newCart;
    }


    const reby = async (order_id) => {
        setProcessing(true);
        var newCart = await service.reby({ id: cart.id, order_id })
        setCart(newCart);
        setProcessing(false);
        return newCart;
    }








    const removeFromCart = async (lineItemId) => {
        // if (!cart) return;
        // const { cart: updatedCart } = await medusaClient.carts.lineItems.delete(cart.id, lineItemId);
        // setCart(updatedCart);
    };

    return (
        <CartContext.Provider value={{ cart, create, addMultiItemToCart, addToCart, updateLineItem, removeLineItem, calculateItemPrice, updateShippingAddress, createInvoiceFile, completeCart, validateInventory, setVoucher, removeVoucher, setPoint, removePoint, reby }}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    return useContext(CartContext);
}